import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { UserOutput } from "~@/graphql/codegen/generated";

export enum OperatorMethod {
  Update = "update",
  Create = "create",
  Delete = "delete",
}

interface OperatorsState {
  selectedOperator?: UserOutput;
  method: OperatorMethod;
  search: string;
}

const initialState: OperatorsState = {
  selectedOperator: undefined,
  method: OperatorMethod.Update,
  search: "",
};

const operatorsSlice = createSlice({
  name: "operators",
  initialState,
  reducers: {
    setSelectedOperator(state, action: PayloadAction<UserOutput | undefined>) {
      state.selectedOperator = action.payload;
    },
    clearSelectedOperator(state) {
      state.selectedOperator = undefined;
    },
    setMethod(state, action: PayloadAction<OperatorMethod>) {
      state.method = action.payload;
    },
    setSearch(state, action: PayloadAction<string>) {
      state.search = action.payload;
    },
  },
});

export const {
  setSelectedOperator,
  clearSelectedOperator,
  setMethod,
  setSearch,
} = operatorsSlice.actions;

export default operatorsSlice.reducer;
